import _regeneratorRuntime from "/app/node_modules/@babel/runtime/regenerator/index.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useMemo, useEffect } from 'react';
import RcRate from 'rc-rate';
import { noop } from 'lodash-es';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useDesignContext } from '../../design-provider';
import { classNames } from '../utils/classnames';
import { AspectRatioView } from './aspect-ratio-view';
import { Price } from './price';
import { GoodsCardSale } from './goods-card-sale';
import { getImageSrc } from '../utils/get-image-src';
import { PromotionLabel } from './promotion-label';
// import { getFirstImage } from '../utils/get-first-image';
import ICON_FAVORITE from '../images/icon-favorite.png';
import ICON_ADD_CART from '../images/icon-ahaa-add-cart.png';
import ICON_ADD_PC_CART from '../images/icon-add-pc-cart.png';
import ICON_LIKE from '../images/icon-like.png';
import ICON_AHAA_PROMOTION_LABEL from '../images/icon-ahaa-promotion-label.png';
import { InputNumber } from './input-number';
import { ProductLable } from './product-label';
import { getLanguageImage } from '../utils/get-language-image';
import { getFirstImage } from '../utils/get-first-image';
export var AhaaGoodsCard = function AhaaGoodsCard(props) {
  var className = props.className,
    style = props.style,
    _props$enableAddCart = props.enableAddCart,
    enableAddCart = _props$enableAddCart === void 0 ? true : _props$enableAddCart,
    _props$enableSale = props.enableSale,
    enableSale = _props$enableSale === void 0 ? false : _props$enableSale,
    saleLeftTime = props.saleLeftTime,
    _props$goods = props.goods,
    goods = _props$goods === void 0 ? {} : _props$goods,
    _props$showRate = props.showRate,
    showRate = _props$showRate === void 0 ? false : _props$showRate,
    _props$onAddCart = props.onAddCart,
    onAddCart = _props$onAddCart === void 0 ? noop : _props$onAddCart,
    onCollect = props.onCollect,
    _props$onSaleEnd = props.onSaleEnd,
    onSaleEnd = _props$onSaleEnd === void 0 ? noop : _props$onSaleEnd;
  var _useDesignContext = useDesignContext(),
    local = _useDesignContext.local,
    language = _useDesignContext.language,
    countStatistics = _useDesignContext.countStatistics,
    productDefaultImage = _useDesignContext.productDefaultImage,
    designOnLink = _useDesignContext.designOnLink;
  var linkPath = designOnLink({
    linkType: 'product',
    linkParams: {
      name: goods.cskuName,
      id: goods.csku,
      csku: goods.csku
    }
  });
  var _useState = useState(false),
    favorite = _useState[0],
    setFavorite = _useState[1];
  var _useState2 = useState(1),
    count = _useState2[0],
    setCount = _useState2[1];
  var cartNumber = useMemo(function () {
    var _a;
    var key = [goods.csku, goods.goodsSpec].filter(Boolean).join('-');
    return (_a = countStatistics[key]) !== null && _a !== void 0 ? _a : 0;
  }, [countStatistics]);
  useEffect(function () {
    setFavorite(goods.isFavorite);
  }, [goods.isFavorite]);
  var sellText = useMemo(function () {
    /** 商品已下架 */
    if ((goods === null || goods === void 0 ? void 0 : goods.onShelves) === 2) {
      return local.goods.unShelve;
    }
    /** 商品预售中 */
    if (goods === null || goods === void 0 ? void 0 : goods.sellFlag) {
      return local.goods.preSale;
    }
    /** 商品已售罄 */
    if (goods === null || goods === void 0 ? void 0 : goods.soldOutStatus) {
      return local.goods.soldOut;
    }
    return '';
  }, [goods]);
  var hasLinePrice = goods.originPrice && goods.salePrice && +goods.originPrice > +goods.salePrice;
  return _jsxs("a", Object.assign({
    className: classNames('group relative w-full border border-ahaa-black-5 rounded bg-white cursor-pointer', 'cq-pc:hover:border-[#4C4C4C]', 'block', className),
    style: style,
    href: linkPath
  }, {
    children: [_jsxs(AspectRatioView, Object.assign({
      className: classNames('w-full rounded overflow-hidden')
    }, {
      children: [!goods.prominentFlag && _jsx(PromotionLabel, {
        imgSrc: ICON_AHAA_PROMOTION_LABEL,
        className: 'z-1 w-15.5 h-5.5 absolute left-2 top-2',
        promotion: goods.promotionLabel
      }), goods.memberPricePicUrl && _jsx("img", {
        className: 'z-1 w-15.5 h-6 absolute left-2 top-2',
        src: goods.memberPricePicUrl
      }), _jsx(LazyLoadImage, {
        className: classNames('w-full h-full', {
          'opacity-50': sellText
        }),
        src: getImageSrc(getFirstImage(goods.customPictures, productDefaultImage))
      }), goods.prominentFlag && _jsx("img", {
        className: 'absolute top-0 left-0 w-full h-full',
        src: getImageSrc(getLanguageImage(language, 'living'))
      }), sellText && _jsx("div", Object.assign({
        className: classNames('absolute bottom-0 left-0 right-0 flex items-center justify-center h-8 text-xs font-medium text-white bg-[rgba(0,0,0,0.5)]', 'cq-pc:h-10 cq-pc:text-sm')
      }, {
        children: sellText
      })), cartNumber > 0 && _jsx("div", Object.assign({
        className: classNames('absolute bg-food-primary text-white rounded-full text-center right-2 bottom-2 flex items-center justify-center font-normal', 'w-4.5 h-4.5 text-xs', 'pc:w-6 pc:h-6 pc:text-sm')
      }, {
        children: cartNumber
      }))]
    })), _jsxs("div", Object.assign({
      className: classNames('p-2 w-full', 'cq-pc:p-3 cq-pc:pt-2')
    }, {
      children: [_jsx("div", Object.assign({
        className: classNames('text-xs font-medium text-ahaa-black-1 line-clamp-1', 'cq-pc:text-sm')
      }, {
        children: goods.brandName
      })), _jsx("div", Object.assign({
        className: classNames('mt-1 text-sm text-ahaa-black-1 line-clamp-2 h-10', 'cq-pc:h-12 cq-pc:text-base')
      }, {
        children: goods.cskuName || goods.name
      })), showRate && _jsx(RcRate, {
        className: 'mt-1',
        value: 4,
        disabled: true
      }), _jsx("div", Object.assign({
        className: classNames('line-clamp-1')
      }, {
        children: _jsxs("div", Object.assign({
          className: classNames('mt-1 flex flex-wrap', 'h-3.5', 'cq-pc:h-4.5 cq-pc:mt-4')
        }, {
          children: [_jsx(ProductLable, {
            labelData: goods.marketingLabel,
            className: classNames('mx-1 border border-ahaa-red-6 bg-ahaa-red-6 rounded-sm line-clamp-1 h-full first:ml-0 text-white')
          }), _jsx(ProductLable, {
            type: 'promotion',
            labelData: goods.disLabel,
            className: classNames('mx-1 border border-ahaa-red-7 bg-ahaa-red-5 rounded-sm h-full line-clamp-1 text-ahaa-red-6', {
              'first:ml-0': !goods.marketingLabel
            })
          })]
        }))
      })), _jsxs("div", Object.assign({
        className: classNames('flex mt-1', 'cq-pc:mt-2')
      }, {
        children: [_jsxs("div", Object.assign({
          className: classNames('flex-1 flex flex-col', 'cq-pc:flex-row cq-pc:items-center cq-pc:line-clamp-1')
        }, {
          children: [_jsx(Price, Object.assign({
            className: classNames('mr-1 text-base font-medium text-ahaa-black-7', 'cq-pc:text-lg', {
              'text-ahaa-red-1': hasLinePrice
            })
          }, {
            children: goods.salePrice
          })), hasLinePrice ? _jsx(Price, Object.assign({
            className: classNames('text-[13px] text-ahaa-black-3', 'cq-pc:text-sm'),
            lineThrough: true
          }, {
            children: goods.originPrice
          })) : _jsx("div", {
            className: classNames('h-4', 'pc:h-0')
          })]
        })), enableAddCart && (goods === null || goods === void 0 ? void 0 : goods.onShelves) !== 2 && !(goods === null || goods === void 0 ? void 0 : goods.soldOutStatus) && !(goods === null || goods === void 0 ? void 0 : goods.sellFlag) ? _jsx("button", Object.assign({
          className: classNames('flex-shrink-0 w-6 h-6', 'cq-pc:hidden'),
          onClick: function onClick(e) {
            e.preventDefault();
            onAddCart(goods, 1);
          }
        }, {
          children: _jsx("img", {
            className: 'w-full h-full',
            src: getImageSrc(ICON_ADD_CART)
          })
        })) : null]
      })), enableSale && _jsx(GoodsCardSale, {
        leftTime: saleLeftTime,
        onEnd: onSaleEnd
      })]
    })), _jsx("button", Object.assign({
      className: classNames('absolute top-3 right-3 hidden w-9 h-9 bg-white rounded-full p-0', 'cq-pc:group-hover:block'),
      onClick: function onClick(event) {
        return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var res;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                event.preventDefault();
                if (!onCollect) {
                  _context.next = 6;
                  break;
                }
                _context.next = 4;
                return onCollect(goods, favorite);
              case 4:
                res = _context.sent;
                if (res) {
                  setFavorite(function (val) {
                    return !val;
                  });
                }
              case 6:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
      }
    }, {
      children: _jsx("img", {
        className: 'w-full h-full',
        src: getImageSrc(favorite ? ICON_FAVORITE : ICON_LIKE)
      })
    })), enableAddCart && (goods === null || goods === void 0 ? void 0 : goods.onShelves) !== 2 && !(goods === null || goods === void 0 ? void 0 : goods.soldOutStatus) && !(goods === null || goods === void 0 ? void 0 : goods.sellFlag) ? _jsx("div", Object.assign({
      className: classNames('absolute left-0 right-0 bottom-0 hidden p-3 rounded-bl-lg rounded-br-lg bg-gradient-to-t from-white to-[rgba(255,255,255,0.5)]', 'pc:group-hover:flex')
    }, {
      children: _jsxs("div", Object.assign({
        className: classNames('bg-white flex pt-5 w-full')
      }, {
        children: [_jsx(InputNumber, {
          className: 'flex-1',
          min: 1,
          max: 99,
          value: count,
          onChange: setCount
        }), _jsx("button", Object.assign({
          className: 'flex-shrink-0 flex items-center justify-center ml-2 w-9 h-9 rounded-sm bg-food-primary',
          onClick: function onClick(e) {
            e.preventDefault();
            onAddCart(goods, count);
          }
        }, {
          children: _jsx("img", {
            className: 'w-full h-full',
            src: getImageSrc(ICON_ADD_PC_CART)
          })
        }))]
      }))
    })) : null]
  }));
};